var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2475 20.2868L13.5 17.6868L17.7525 20.3211L16.6388 15.3947L20.385 12.1105L15.4575 11.6658L13.5 7.01316L11.5425 11.6316L6.615 12.0763L10.3613 15.3947L9.2475 20.2868ZM5.16375 26L7.3575 16.3868L0 9.92105L9.72 9.06579L13.5 0L17.28 9.06579L27 9.92105L19.6425 16.3868L21.8363 26L13.5 20.9026L5.16375 26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.1eee06b0262039c1f06cff7b5455602c.svg";
export { ForwardRef as ReactComponent };